// Single-training detail (GET /training/:id) — backs TrainingDetailsModal.
const action = "TRAINING_DETAIL";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { trainingId }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
